import React from 'react';
import DashboardLayout from '../../components/layout/DashboardLayout';
import ComingSoon from '../../components/common/ComingSoon';

const RolesPage: React.FC = () => {
  return (
    <DashboardLayout>
      <ComingSoon 
        title="Roles & Permissions"
        description="Comprehensive role-based access control system is under development. Manage user roles and permissions with ease."
        backTo="/dashboard"
        backLabel="Back to Dashboard"
        layout="admin"
      />
    </DashboardLayout>
  );
};

export default RolesPage;